'use client';

import { useField } from 'formik';
import { FC } from 'react';

import { InputFormikProps } from './Input.type';
import { InputTime } from './InputTime';

/**
 * Input field expected to be used within a Formik context
 */
export const InputTimeFormik: FC<InputFormikProps<typeof InputTime>> = (props) => {
  const [field, meta, helpers] = useField(props.name);

  return (
    <InputTime
      {...props}
      value={field.value}
      error={meta.error && meta.touched ? meta.error : undefined}
      onChange={(value) => helpers.setValue(value)}
      onBlur={field.onBlur}
    />
  );
};
